import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CribIcon(props: IconProps) {
    return <Icon {...props} iconKey={"crib"}/>
}
